import BasicModel from "./basic_model";

export default class Player extends BasicModel {

  render = function () {
    this.setupContext();

    const x = this.x();
    const y = this.y();
    const s = this.context.scale;

    // Draw hands

    this.context.fillStyle = "rgba(245, 223, 166, 1)";
    this.context.strokeStyle = "rgba(200, 180, 125, 1)";

    this.context.beginPath();
    this.context.moveTo(x - 13 * s, y + 9 * s);
    this.context.lineTo(x - 8 * s, y + 9 * s);
    this.context.lineTo(x - 7 * s, y + 3 * s);
    this.context.lineTo(x + 7 * s, y + 3 * s);
    this.context.lineTo(x + 8 * s, y + 9 * s);
    this.context.lineTo(x + 13 * s, y + 9 * s);
    this.context.lineTo(x + 12 * s, y + 3 * s);
    this.context.lineTo(x - 12 * s, y + 3 * s);
    this.context.stroke();
    this.context.fill();


    // Draw body

    this.setVariationColors();
    this.context.beginPath();
    this.context.moveTo(x, y - 7 * s);
    this.context.quadraticCurveTo(x + 18 * s, y - 7 * s, x + 15 * s, y + 7 * s);
    this.context.lineTo(x + 7 * s, y + 3 * s);
    this.context.lineTo(x + 7 * s, y - 4 * s);
    this.context.lineTo(x - 7 * s, y - 4 * s);
    this.context.lineTo(x - 7 * s, y + 3 * s);
    this.context.lineTo(x - 15 * s, y + 7 * s);
    this.context.quadraticCurveTo(x - 18 * s, y - 7 * s, x, y - 7 * s);
    this.context.stroke();
    this.context.fill();


    // Draw head

    this.context.fillStyle = "rgba(245, 223, 166, 1)";
    this.context.strokeStyle = "rgba(160, 140, 85, 1)";

    this.context.beginPath();
    this.context.arc(x, y, 7 * s, 0, 2 * Math.PI, true);
    this.context.stroke();
    this.context.fill();

    this.resetContext()
  }

  boundingBox = function () {
    const x = this.x();
    const y = this.y();
    const w = 15;
    const h = 10;
    const s = this.context.scale;

    return {
      x: x - w * s,
      y: y - h * s,
      w: 2 * w * s,
      h: 2 * h * s
    }
  }

}

